import { GuestCustomerRelationModel } from 'api-hooks/guest';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import { CardContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  data: GuestCustomerRelationModel[];
  isLoading: boolean;
}

export default function CustomerRelationTable(props: Props) {
  const { t } = useTranslation();
  const { data, isLoading } = props;

  const columns = React.useMemo<IColumn<GuestCustomerRelationModel>[]>(
    () => [
      {
        header: t(`common:customer`),
        accessorKey: 'name',
        minSize: 100,
      },
      {
        header: t('common:number_of_sales'),
        accessorKey: 'noOfSales',
        minSize: 100,
      },
    ],
    [t],
  );

  return (
    <CardContainer>
      <Text variant="HeadingXSmall">{t('customer:customer_relations')}</Text>
      <Separator gap={16} />
      <TableComponent
        columns={columns}
        isLoading={isLoading}
        data={data || []}
      />
    </CardContainer>
  );
}
